<cac-table [options]="table" (clickRow)="onRowClick($event)" #tableRef>
    <div slot="header-start" class="flex gap-2 items-center">
        <cac-table-column-selector [tableRef]="tableRef" [storageKey]="'products-table'" [label]="'Visible Columns'"
            [placeholder]="'Choose columns to display'">
        </cac-table-column-selector>

        <cac-field
            [control]="searchControl"
            placeholder="Search products..."
            suffixIcon="search"
            [clearable]="true"
            appearance="outlined"
            class="w-64">
        </cac-field>
    </div>